/* Native court-sport runtime: section-scoped, editor reload-safe. */
(function(){
  'use strict';
  var instances=new Map();
  function initialize(host){
    if(instances.has(host)) instances.get(host)();
    var controller=new AbortController(), observers=[], frames=new Set(), timers=new Set(), intervals=new Set();
    function getId(id){return host.querySelector('[id="'+id+'"]');}
    function config(section,key,fallback){var element=host.querySelector('[data-court-section="'+section+'"][data-court-setting="'+key+'"]');return element?element.dataset.value:fallback;}
    function listen(target,event,callback,options){if(target)target.addEventListener(event,callback,Object.assign({},typeof options==='object'?options:{capture:!!options},{signal:controller.signal}));}
    function observe(callback,options){var observer=new IntersectionObserver(callback,options);observers.push(observer);return observer;}
    function courtFrame(callback){var id=requestAnimationFrame(function(time){frames.delete(id);callback(time);});frames.add(id);return id;}
    function courtLater(callback,delay){var id=setTimeout(function(){timers.delete(id);callback();},delay);timers.add(id);return id;}
    function courtInterval(callback,delay){var id=setInterval(callback,delay);intervals.add(id);return id;}
    instances.set(host,function(){controller.abort();observers.forEach(function(o){o.disconnect();});frames.forEach(cancelAnimationFrame);timers.forEach(clearTimeout);intervals.forEach(clearInterval);instances.delete(host);});
    /* Approved Tennis 10:4/ketoneaid-sport-tennis-v8.html; native interactions. */

(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Share strip: COPY LINK with clipboard + fallback, TEXT/EMAIL are plain links. */
  (function(){
    var btn=getId('shareCopy'); if(!btn) return;
    var label=btn.textContent;
    listen(btn, 'click',function(){
      var url=btn.getAttribute('data-url');
      function done(ok){ btn.textContent= ok ? config('study', 'copy_success', 'COPIED') : config('study', 'copy_failure', 'COPY FAILED'); btn.classList.toggle('is-done',ok); courtLater(function(){ btn.textContent=label; btn.classList.remove('is-done'); },1800); }
      function legacy(){ try{ var ta=document.createElement('textarea'); ta.value=url; ta.setAttribute('readonly',''); ta.style.position='fixed'; ta.style.opacity='0'; document.body.appendChild(ta); ta.select(); var ok=document.execCommand('copy'); document.body.removeChild(ta); done(ok); }catch(e){ done(false); } }
      if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(url).then(function(){done(true)},legacy); return; }
      legacy(); if(false){ }
    });
  })();

  /* Rally. Win one rally (get one ball past the computer) to reveal the free-shipping signup link.
     Never autoplays; the loop runs only while a rally is live, the section is on screen and the tab is visible.
     A lost rally ends neutrally: the rally length and play again. Nothing in here names a product.
     PROGRAMMER: set KLAVIYO_FORM_ID to the free-shipping signup popup (Klaviyo form ID). The button opens that popup;
     FALLBACK_URL is used only if Klaviyo hasn't loaded. */
  (function(){
    var KLAVIYO_FORM_ID=config('rally', 'klaviyo_form', ''), FALLBACK_URL=config('rally', 'fallback_url', 'https://ketoneaid.com/');
    var box=getId('tnCourt'); if(!box) return;
    var cv=box.querySelector('canvas'), ctx=cv&&cv.getContext('2d'); if(!ctx) return;
    var ov=getId('tnOverlay'), ovH=getId('tnOvH'), ovS=getId('tnOvS');
    var start=getId('tnStart'), claim=getId('tnClaim');
    var eRally=getId('tnRally'), eBest=getId('tnBest'), eWon=getId('tnWon');
    listen(claim, 'click',function(e){ e.stopPropagation();
      if(KLAVIYO_FORM_ID){ window._klOnsite=window._klOnsite||[]; window._klOnsite.push(['openForm',KLAVIYO_FORM_ID]); }
      else { window.location.href=FALLBACK_URL; }
    });
    var W=800,H=450,PW=12,PH=84,R=8,LX=30,RX=W-30;
    var st={live:false,py:H/2,cy:H/2,target:H/2,bx:W/2,by:H/2,vx:0,vy:0,serveAt:0,rally:0,keys:0,err:0};
    var best=0, won=0, onScreen=false, raf=0, last=0;
    function fit(){ var dpr=Math.min(2,window.devicePixelRatio||1); cv.width=W*dpr; cv.height=H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); draw(); }
    function hud(){ eRally.textContent=st.rally; eBest.textContent=best; eWon.textContent=won; }
    function clamp(v,a,b){ return Math.max(a,Math.min(b,v)); }
    function hit(py,dir){
      var off=clamp((st.by-py)/(PH/2),-1,1), sp=Math.min(12.5,Math.hypot(st.vx,st.vy)*1.06), a=off*.85;
      st.vx=Math.cos(a)*sp*dir; st.vy=Math.sin(a)*sp; st.rally++; if(st.rally>best) best=st.rally;
      st.err=(Math.random()*2-1)*(28+st.rally*6);   /* the computer misjudges more as the rally speeds up */
      hud();
    }
    function finish(youWon){
      st.live=false; box.classList.remove('is-live'); stop();
      if(youWon){ won++; ovH.textContent=config('rally', 'won_heading', 'You won the rally.'); ovS.textContent=config('rally', 'won_body', 'FREE SHIPPING IS YOURS. SIGN UP TO CLAIM IT.'); claim.hidden=false; start.textContent=config('rally', 'play_again', 'PLAY AGAIN &rarr;'); }
      else { ovH.textContent=config('rally', 'lost_heading', 'Point, computer.'); ovS.innerHTML=config('rally', 'rally_length', 'RALLY LENGTH: ')+st.rally+(st.rally===1?config('rally', 'shot_singular', ' SHOT'):config('rally', 'shot_plural', ' SHOTS'))+config('rally', 'best_today', '. BEST TODAY: ')+best+'.'; claim.hidden=!won; start.textContent=config('rally', 'play_again', 'PLAY AGAIN &rarr;'); }
      hud(); ov.hidden=false; draw();
    }
    function step(dt,now){
      var k=dt/16.667;
      if(st.keys) st.target=clamp(st.target+st.keys*9*k,PH/2,H-PH/2);
      st.py+=(st.target-st.py)*Math.min(1,.4*k); st.py=clamp(st.py,PH/2,H-PH/2);
      var aim=(st.vx>0?st.by+st.err:H/2), cs=4.3*k; st.cy+=clamp(aim-st.cy,-cs,cs); st.cy=clamp(st.cy,PH/2,H-PH/2);
      if(!st.vx&&!st.vy){ if(now>=st.serveAt){ var a=(Math.random()*.6-.3); st.vx=-Math.cos(a)*6; st.vy=Math.sin(a)*6; } return; }
      var px=st.bx; st.bx+=st.vx*k; st.by+=st.vy*k;
      if(st.by<R){ st.by=R; st.vy=Math.abs(st.vy); } if(st.by>H-R){ st.by=H-R; st.vy=-Math.abs(st.vy); }
      var lp=LX+PW/2, rp=RX-PW/2;   /* swept checks: the ball can't tunnel through a racquet at speed */
      if(st.vx<0&&px-R>=lp&&st.bx-R<lp&&Math.abs(st.by-st.py)<=PH/2+R){ st.bx=lp+R; hit(st.py,1); }
      else if(st.vx>0&&px+R<=rp&&st.bx+R>rp&&Math.abs(st.by-st.cy)<=PH/2+R){ st.bx=rp-R; hit(st.cy,-1); }
      if(st.bx<-R*2) finish(false); else if(st.bx>W+R*2) finish(true);
      cv.dataset.by=Math.round(st.by); cv.dataset.bx=Math.round(st.bx);
    }
    function draw(){
      ctx.fillStyle=config('rally', 'court_color_1', '#24503F'); ctx.fillRect(0,0,W,H);
      ctx.strokeStyle=config('rally', 'court_color_2', 'rgba(255,255,255,.85)'); ctx.lineWidth=3; ctx.strokeRect(14,14,W-28,H-28);
      ctx.beginPath(); ctx.moveTo(14,70); ctx.lineTo(W-14,70); ctx.moveTo(14,H-70); ctx.lineTo(W-14,H-70);
      ctx.moveTo(W/2-190,70); ctx.lineTo(W/2-190,H-70); ctx.moveTo(W/2+190,70); ctx.lineTo(W/2+190,H-70);
      ctx.moveTo(W/2-190,H/2); ctx.lineTo(W/2+190,H/2); ctx.stroke();
      ctx.fillStyle=config('rally', 'court_color_3', 'rgba(255,255,255,.9)'); ctx.fillRect(W/2-2,6,4,H-12);
      ctx.fillStyle=config('rally', 'court_color_4', '#F4F6F4'); ctx.fillRect(LX-PW/2,st.py-PH/2,PW,PH); ctx.fillRect(RX-PW/2,st.cy-PH/2,PW,PH);
      ctx.fillStyle=config('rally', 'court_color_5', '#D8F35A'); ctx.beginPath(); ctx.arc(st.bx,st.by,R,0,Math.PI*2); ctx.fill();
    }
    function loop(now){ raf=0; if(!st.live||!onScreen||document.hidden) return; var dt=last?Math.min(40,now-last):16.667; last=now; step(dt,now); draw(); if(st.live) raf=courtFrame(loop); }
    function go(){ if(!raf&&st.live&&onScreen&&!document.hidden){ last=0; raf=courtFrame(loop); } }
    function stop(){ if(raf){ cancelAnimationFrame(raf); raf=0; } }
    function begin(){
      st.bx=W/2; st.by=H/2; st.vx=0; st.vy=0; st.rally=0; st.err=0; st.py=st.cy=st.target=H/2; hud();
      st.live=true; ov.hidden=true; box.classList.add('is-live'); box.focus({preventScroll:true});
      st.serveAt=performance.now()+700; go();
    }
    function aimFrom(e){ var r=cv.getBoundingClientRect(); st.target=clamp((e.clientY-r.top)/r.height*H,PH/2,H-PH/2); }
    listen(start, 'click',function(e){ e.stopPropagation(); begin(); });
    listen(box, 'pointermove',function(e){ if(st.live) aimFrom(e); });
    listen(box, 'pointerdown',function(e){ if(st.live){ e.preventDefault(); aimFrom(e); } });
    listen(box, 'keydown',function(e){
      var up=(e.key==='ArrowUp'||e.key==='w'||e.key==='W'), dn=(e.key==='ArrowDown'||e.key==='s'||e.key==='S');
      if(up||dn){ e.preventDefault(); st.keys=up?-1:1; } else if((e.key===' '||e.key==='Enter')&&!st.live&&!ov.hidden){ e.preventDefault(); begin(); }
    });
    listen(box, 'keyup',function(e){ if(['ArrowUp','ArrowDown','w','W','s','S'].indexOf(e.key)>-1) st.keys=0; });
    if('IntersectionObserver' in window){ observe(function(es){ es.forEach(function(en){ onScreen=en.isIntersecting; if(onScreen) go(); else stop(); }); },{threshold:.2}).observe(box); } else { onScreen=true; }
    listen(document, 'visibilitychange',function(){ if(document.hidden) stop(); else go(); });
    listen(window, 'resize',draw);
    fit(); hud();
  })();

  /* Concentration slider — ported verbatim (behaviour) from the home page #pick module. */
  (function(){
    var range=getId('concRange'), out=getId('concOut');
    if(!range||!out) return;
    var DATA=Array.prototype.map.call(host.querySelectorAll('.ladder .rung'), function(card){
  var pct=card.querySelector('.pct'), emoji=card.querySelector('.fEmoji');
  return {pct:pct ? pct.firstChild.textContent.trim()+'%' : '', name:(card.querySelector('.rname')||card).textContent.trim(), per:card.getAttribute('data-court-price')||'', emoji:emoji ? emoji.textContent : ''};
});
    var concentrationLabel=out.childNodes[1] ? out.childNodes[1].textContent : ' Veech Ketone Ester · ';
    var rungs=Array.prototype.slice.call(host.querySelectorAll('.ladder .rung'));
    var thumb=getId('concThumb');
    host.querySelectorAll('.rungImg').forEach(function(img){
      [img.dataset.sel,img.dataset.x].forEach(function(u){ if(u){ var pre=new Image(); pre.src=u; } });
    });
    function apply(){
      var i=parseInt(range.value,10), d=DATA[i]; if(!d) return;
      out.replaceChildren(); var bold=document.createElement('b'), price=document.createElement('span'); bold.textContent=d.pct; price.textContent=d.per; out.append(bold,document.createTextNode(concentrationLabel),price);
      if(thumb){ thumb.textContent=d.emoji; thumb.style.left='calc('+(i/(DATA.length-1))*100+'% + '+(24-(i/(DATA.length-1))*48)+'px)'; }
      rungs.forEach(function(r,k){
        var on=(k===i); r.classList.toggle('win',on);
        var img=r.querySelector('.rungImg');
        if(img){ var next=on?img.dataset.sel:img.dataset.x; if(next&&img.getAttribute('src')!==next) img.setAttribute('src',next); }
      });
    }
    listen(range, 'input',apply);
    rungs.forEach(function(r,k){ listen(r, 'mouseenter',function(){ if(parseInt(range.value,10)===k) return; range.value=k; apply(); }); });
    apply();

})();

  /* Teams + Tracks: single Ke2 rotates in with scroll (rAF + IntersectionObserver). Reduced motion: static -6deg. */
  (function(){
    var ke2=getId('clubsKe2'); if(!ke2) return;
    if(reduce || !('IntersectionObserver' in window)){ ke2.style.transform='rotate(-6deg)'; return; }
    var live=false, raf=0;
    function tick(){
      raf=0;
      var r=ke2.getBoundingClientRect(), vh=window.innerHeight||1;
      var p=Math.min(1,Math.max(0,(vh-r.top)/(vh+r.height)));
      var deg=-22+p*32;
      ke2.style.transform='rotate('+deg.toFixed(2)+'deg)';
    }
    function onScroll(){ if(live && !raf) raf=courtFrame(tick); }
    observe(function(es){ es.forEach(function(e){ live=e.isIntersecting; if(live) onScroll(); }); },{rootMargin:'20% 0px'}).observe(ke2);
    listen(window, 'scroll',onScroll,{passive:true}); listen(window, 'resize',onScroll);
    tick();

})();


})();

  }
  function boot(){var root=document.getElementById('ka-goal');if(root)initialize(root);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',function(){var root=document.getElementById('ka-goal');if(root)initialize(root);});
  document.addEventListener('shopify:section:unload',function(){instances.forEach(function(cleanup){cleanup();});});
})();
